/**
 * The game's clock against the real one: a hit-stop holds the game still for a moment, a slow motion runs it slower for
 * a while. The crowd, the HUD and the camera shake keep real time; the fighters and the rules take the game's.
 */
export class TimeWarp {
  private frozenFor = 0;
  private slowFor = 0;
  private slowScale = 1;

  /** Holds the game still for this many real seconds, unless it is already held longer. */
  freeze(seconds: number): void {
    this.frozenFor = Math.max(this.frozenFor, seconds);
  }

  /** Runs the game at this share of its speed for this many real seconds. */
  slow(scale: number, seconds: number): void {
    this.slowScale = scale;
    this.slowFor = seconds;
  }

  /** How much game time passes in this much real time. */
  advance(real: number): number {
    const frozen = Math.min(real, this.frozenFor);
    this.frozenFor -= frozen;
    let left = real - frozen;
    const slowed = Math.min(left, this.slowFor);
    this.slowFor -= slowed;
    left -= slowed;
    return slowed * this.slowScale + left;
  }
}
